<template>
  <div>
    <div class="page-title">Edit Venue Events List</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Venue Events List"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.venue-events-lists.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "Edit Venue Event",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.VenueEventsList.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.VenueEventsList.update(this.form);
      this.$router.push("/widgets/venue-events-lists");
    },
  },
};
</script>

<style></style>
